import publicApiClient from '../clients/publicApiClient';
import { API_ENDPOINTS } from '../endpoints';

export const legalDocumentsApi = {
  getActive() {
    return publicApiClient.get(API_ENDPOINTS.legalDocuments.getActive);
  },

  getExact({ slug } = {}) {
    return publicApiClient.get(API_ENDPOINTS.legalDocuments.getExact, {
      params: { slug },
    });
  },
};
